import React, { useEffect, Suspense } from "react";
import { BrowserRouter, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.css";
import "./i18n/i18n";
import { LanguageProvider } from "./context/LanguageContext";
import { ChatProvider } from "./context/chat.context";
import { loadAllTranslations, applyLocalTranslations } from "./i18n/translationsService";
import { routes } from "./router";
import { AuthContext } from "./context/auth.context";
import RouterCombiner from "./router/routeCombiner";
import Banners from "./components/banners";
import "./assets/styles/global.scss";
import { useAmplitude } from "./hooks/useAmplitude";
import LocationProvider from "./router/LocationProvider";
import ToolsIcon from "./components/shared/icons/ToolsIcon";
import Loading from "./components/shared/Loading/Loading";
import ReportPanel from "./components/report-panel/ReportPanel";

function App({ login, logout, isAuthenticated, checkDone, session, retrySessionData, userType }) {
  const { amplitude } = useAmplitude();
  const isDev = process.env.NODE_ENV === "development";
  useEffect(() => {
    amplitude.init();
  }, []);
  useEffect(() => {
    applyLocalTranslations();
  }, []);
  useEffect(() => {
    if (!isAuthenticated) return;
    const timer = setTimeout(() => {
      loadAllTranslations(true).catch((error) => {
        console.error("Ошибка при обновлении переводов после входа:", error);
      });
    }, 500);
    return () => clearTimeout(timer);
  }, [isAuthenticated]);

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        isAuthenticated,
        checkDone,
        sessionId: session.sessionId,
      }}
    >
      <Suspense fallback={<Loading />}>
        <LanguageProvider>
          <BrowserRouter>
            <ChatProvider key={session.sessionId || "anonymous"} enabled={session.status === "ready"}>
              <Banners.Warning />
              <LocationProvider>
                <RouterCombiner
                  routes={routes}
                  auth={isAuthenticated}
                  checkDone={checkDone}
                  session={session}
                  retry={retrySessionData}
                  userType={userType}
                />
              </LocationProvider>
              {isDev && (
                <Link className="dev-link" to="/develop/icons">
                  <ToolsIcon />
                </Link>
              )}
              <ReportPanel />
            </ChatProvider>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </BrowserRouter>
        </LanguageProvider>
      </Suspense>
    </AuthContext.Provider>
  );
}
export default App;
